import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useToggle } from "react-use";
import { useGetAuthenticatedUserQuery } from "@/api/authentication";

interface Props {
  onRefresh: () => void;
}

export const SessionTimeoutWarningModal: React.FC<Props> = ({ onRefresh }) => {
  const [isOpen, toggleIsOpen] = useToggle(true);
  const { refetch, isLoading } = useGetAuthenticatedUserQuery();

  const handleExtend = async () => {
    await refetch().unwrap();

    onRefresh();
    toggleIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={toggleIsOpen}>
      <DialogContent className="max-w-[350px]">
        <DialogHeader>
          <DialogTitle>Session Timeout warning</DialogTitle>
          <DialogDescription>Your session will expire in 2 minutes.</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={toggleIsOpen}>
            Cancel
          </Button>
          <Button variant="default" onClick={handleExtend} disabled={isLoading}>
            {isLoading ? "Extending..." : "Extend"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
